/**
 * KPI/stat card — redesigned with Sora numbers, DM Sans labels, pill trend badge.
 * Props: icon, iconColor, label, value, trend (number %), trendLabel, subtitle
 */
export default function DashboardStatCard({ icon, iconColor = '#0ea5e9', label, value, trend, trendLabel, subtitle }) {
  const isPositive = trend != null && Number(trend) >= 0;
  const trendBg    = trend != null ? (isPositive ? '#dcfce7' : '#fee2e2') : null;
  const trendColor = trend != null ? (isPositive ? '#15803d' : '#b91c1c') : null;
  const trendArrow = isPositive ? '↑' : '↓';

  return (
    <div
      style={{
        background: '#ffffff',
        border: '1px solid #e2e8f0',
        borderRadius: '14px',
        padding: '1.4rem 1.5rem',
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
        transition: 'box-shadow 0.2s, border-color 0.2s, transform 0.15s',
        display: 'flex',
        alignItems: 'flex-start',
        gap: '1rem',
        cursor: 'default',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.08)';
        e.currentTarget.style.borderColor = `${iconColor}60`;
        e.currentTarget.style.transform = 'translateY(-1px)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.04)';
        e.currentTarget.style.borderColor = '#e2e8f0';
        e.currentTarget.style.transform = 'translateY(0)';
      }}
    >
      {/* Icon box */}
      <div
        style={{
          width: 48,
          height: 48,
          minWidth: 48,
          borderRadius: 12,
          background: `${iconColor}15`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '1.35rem',
          flexShrink: 0,
          color: iconColor,
        }}
      >
        {icon}
      </div>

      {/* Content */}
      <div style={{ flex: 1, minWidth: 0 }}>
        {/* Label */}
        <div
          style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '0.72rem',
            fontWeight: 600,
            color: '#64748b',
            textTransform: 'uppercase',
            letterSpacing: '0.07em',
            marginBottom: '0.35rem',
          }}
        >
          {label}
        </div>

        {/* Value */}
        <div
          style={{
            fontFamily: "'Sora', sans-serif",
            fontSize: '1.8rem',
            fontWeight: 700,
            color: '#0f172a',
            lineHeight: 1.15,
            letterSpacing: '-0.03em',
          }}
        >
          {value}
        </div>

        {/* Subtitle */}
        {subtitle && (
          <div
            style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: '0.78rem',
              color: '#64748b',
              marginTop: '0.2rem',
            }}
          >
            {subtitle}
          </div>
        )}

        {/* Trend pill */}
        {trend != null && (
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.25rem',
              marginTop: '0.55rem',
              padding: '0.2rem 0.6rem',
              borderRadius: '999px',
              background: trendBg,
              color: trendColor,
              fontFamily: "'DM Sans', sans-serif",
              fontSize: '0.75rem',
              fontWeight: 700,
            }}
          >
            <span>{trendArrow}</span>
            <span>
              {isPositive && Number(trend) > 0 ? '+' : ''}
              {trend}%{trendLabel ? ` ${trendLabel}` : ''}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
